export class ReportType {
    constructor(
        public id: string,
        public name: string
    ) { }
}

export class CentreReport {
    constructor(
        public id: string,
        public name: string,
        public isGroup?: boolean
    ) { }
}

export class AgeGroupReport {
    constructor(
        public id: string,
        public name: string
    ) { }
}

export class DestinationReport {
    constructor(
        public id: string,
        public name: string
    ) { }
}

export class DestinationsReport {
    constructor(
        public countryId: string,
        public countryCode: string,
        public countryName: string
    ) { }
}

export class GenderReport {
    constructor(
        public id: string,
        public code: string,
        public name: string,
        public value: string
    ) { }
}

export class GroupReport {
    constructor(
        public id: string,
        public code: string,
        public name: string,
        public value: string
    ) { }
}

export class OccupationsReport {
    constructor(
        public id: string,
        public name: string
    ) { }
}

export class OrganisationReport {
    constructor(
        public id: string,
        public name: string
    ) { }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/report/report.model.ts